import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface GetReservationAnalyticsRequest {
  buildingId?: number
  dateStart?: number
  dateEnd?: number
  enabled?: boolean
}

export interface ReservationAnalytics {
  totalReservations: number
  grossRevenue: number
  cancellationsRefunds: number
  discountsPromotions: number
  netRevenue: number
  paidReservationsGrossTotal: number
  discountedTotal: number
  refundedTotal: number
  paidReservationsNetTotal: number
  cancelledTotal: number
}

export const USE_GET_RESERVATION_ANALYTICS_QUERY_KEY = 'useGetReservationAnalytics'

export const getReservationAnalyticsQueryKey = (data: GetReservationAnalyticsRequest) => [
  USE_GET_RESERVATION_ANALYTICS_QUERY_KEY,
  data,
]

export const getReservationAnalytics = async ({
  buildingId,
  dateStart,
  dateEnd,
}: GetReservationAnalyticsRequest) => {
  const response = await authAPI.get<ReservationAnalytics>('/reservation/analytics', {
    params: { buildingId, dateEnd, dateStart },
  })
  return response.data
}

export const useGetReservationAnalytics = ({
  enabled = true,
  ...data
}: GetReservationAnalyticsRequest) =>
  useQuery({
    enabled: enabled && !!data.buildingId,
    queryFn: () => getReservationAnalytics(data),
    queryKey: getReservationAnalyticsQueryKey(data),
  })
